export default __webpack_public_path__ + "static/dropbox.92095837d487fb58fad7e8154691c776.png";